import { fromJS, List, Map, isImmutable } from 'immutable'
import _ from 'lodash'
import { v4 as uuid } from 'uuid'
import { getCartProductsHash } from '../../hooks/useECommerceValue'
import { ftSetLocalStorage } from '../../lib/common'
import { SET_STORE } from './actionTypes'
import { processButtonAction } from './processButtonAction'
import { processCondRules } from './processCondRules'
import { processSFAutoTrigger } from './processSFAutoTrigger'
import { setElemValue } from './setElemValue'

export const productCloseDlg = () => (dispatch, getState) => {
  dispatch({
    type: SET_STORE,
    payload: {
      store: getState().setIn(['panels', 'productDlg', 'show'], false),
    },
  })
}

export const applyECommerceCoupon = (couponID) => (dispatch, getState) => {
  const state = getState()
  dispatch(setElemValue(['couponKey'], couponID, 'FormField', ['eCommerce']))
  dispatch(processCondRules('eCommerce', null, ['eCommerce']))
  dispatch(processSFAutoTrigger())

  const sfItemID = state
    .getIn(['project', 'Settings', 'sfMapping'], Map())
    .findKey((elem) => elem.get('elemUID') === `e_coupon`)

  const defaultAction = [
    {
      uid: uuid(),
      conditions: [],
      isAction: false,
      actions: {
        sfAction: [
          {
            items: [
              {
                value: sfItemID,
                order: '',
              },
            ],
          },
        ],
      },
    },
  ]
  dispatch(processButtonAction(fromJS(defaultAction), 'eCommerce', false, null))
}

export const resetLocalCart = (projectID) => {
  if (!projectID) {
    return false
  }
  try {
    ftSetLocalStorage(`e_cart_${projectID}`, JSON.stringify([]))
  } catch (err) {}
}

export const changeCartCount = (value, count, item, onUpdate) => (dispatch, getState) => {
  let state = getState()
  if (window.isDisableChangeCart) {
    return false
  }
  let productsHash = getCartProductsHash(state)
  const sfItemID = state
    .getIn(['project', 'Settings', 'sfMapping'], Map())
    .findKey((elem) => elem.get('elemUID') === 'e_cart')

  if (sfItemID) {
    if (window) {
      window.isDisableChangeCart = sfItemID
    }
  }

  const onUpdateItem = state.getIn(
    ['project', 'Settings', 'eCommerce', 'pages', 'e_cart', 'Props', 'onUpdateItem'],
    List()
  )

  let cartData = state.getIn(['state', 'eCommerce', 'e_cart'], List())
  let hashAttributes = {}
  if (item) {
    item.get('attr', List()).map((row) => {
      if (row && isImmutable(row) && row.get('value') !== undefined) {
        hashAttributes[row.get('value')] = true
      }
    })
  } else {
    console.error('not found element')
  }
  const cartItemIndex = cartData.findIndex((cartItem) => {
    if (cartItem.get('value') === value) {
      let isMatchAttr = true
      if (cartItem.get('attr')) {
        let attributes = cartItem
          .get('attr', List())
          .filter((row) => row && isImmutable(row) && row.get('value') !== undefined)
        if (attributes.size != Object.keys(hashAttributes).length) {
          return false
        }
        attributes.map((row) => {
          if (row && isImmutable(row) && row.get('value') !== undefined) {
            if (!hashAttributes[row.get('value')]) {
              isMatchAttr = false
            }
          }
        })
        return isMatchAttr
      } else {
        if (Object.keys(hashAttributes).length == 0) {
          return true
        }
        return false
      }
    } else {
      return false
    }
  })

  if (cartItemIndex !== -1) {
    let item = cartData.get(cartItemIndex, Map())
    let prevCount = parseInt(cartData.getIn([cartItemIndex, 'count']), 10)

    let quantity = parseInt(cartData.getIn([cartItemIndex, 'quantity']))

    if (isNaN(quantity)) {
      cartData = cartData.setIn([cartItemIndex, 'count'], count)
    } else if (prevCount > count) {
      if (quantity >= productsHash[item.get('value')] - 1) {
        cartData = cartData.setIn([cartItemIndex, 'count'], count)
      }
    } else if (quantity >= productsHash[item.get('value')] + 1) {
      cartData = cartData.setIn([cartItemIndex, 'count'], count)
    }
    let cartItem = cartData.getIn([cartItemIndex], Map())
    if (cartItem) {
      cartItem = setSalePrice(cartItem)
    }
    dispatch(setElemValue(['item'], cartItem, 'FormField', ['eCommerce']))
  }

  state = getState()
  state = state.setIn(['state', 'eCommerce', 'e_cart'], cartData)
  setCartToLocalStorage(cartData, state)
  state = state.setIn(
    ['state', 'eCommerce', 'cart'],
    _.uniq(_.compact(cartData.map((item) => item.value).toJS())).join(',')
  )

  dispatch({
    type: SET_STORE,
    payload: {
      store: state,
    },
  })
  dispatch(processCondRules('eCommerce', null, ['eCommerce']))
  dispatch(processSFAutoTrigger())
  if (typeof onUpdate === 'function') {
    onUpdate()
  } else {
    dispatch(processButtonAction(onUpdateItem, 'eCommerce', false, null))
  }
}

export const changeCartAddonCount = (value, addonId, count, item, onUpdate) => (dispatch, getState) => {
  let state = getState()
  if (window.isDisableChangeCart) {
    return false
  }
  const sfItemID = state
    .getIn(['project', 'Settings', 'sfMapping'], Map())
    .findKey((elem) => elem.get('elemUID') === 'e_cart')

  if (sfItemID) {
    if (window) {
      window.isDisableChangeCart = sfItemID
    }
  }
  let productsHash = getCartProductsHash(state)
  const onUpdateItem = state.getIn(
    ['project', 'Settings', 'eCommerce', 'pages', 'e_cart', 'Props', 'onUpdateItem'],
    List()
  )

  let cartData = state.getIn(['state', 'eCommerce', 'e_cart'], List())
  const cartItemIndex = cartData.findIndex((cartItem) => cartItem.get('value') === value)
  if (cartItemIndex !== -1) {
    let addonIndex = item.get('addons', List()).findIndex((addon) => addon.get('Id') === addonId)
    if (addonIndex !== -1) {
      let prevCount = parseInt(cartData.getIn([cartItemIndex, 'addons', addonIndex, 'count']), 10)
      let quantity = cartData.getIn([cartItemIndex, 'addons', addonIndex, 'quantity'])
      if (prevCount > count) {
        if (
          quantity == null ||
          quantity === undefined ||
          parseInt(cartData.getIn([cartItemIndex, 'addons', addonIndex, 'quantity']), 10) >= productsHash[addonId] - 1
        ) {
          cartData = cartData.setIn([cartItemIndex, 'addons', addonIndex, 'count'], count)
        }
      } else if (
        quantity == null ||
        quantity === undefined ||
        parseInt(cartData.getIn([cartItemIndex, 'addons', addonIndex, 'quantity']), 10) >= productsHash[addonId] + 1
      ) {
        cartData = cartData.setIn([cartItemIndex, 'addons', addonIndex, 'count'], count)
      }
    }
    let cartItem = cartData.getIn([cartItemIndex], Map())
    if (cartItem) {
      cartItem = setSalePrice(cartItem)
    }
    dispatch(setElemValue(['item'], cartItem, 'FormField', ['eCommerce']))
  }

  state = getState()
  state = state.setIn(['state', 'eCommerce', 'e_cart'], cartData)
  setCartToLocalStorage(cartData, state)
  state = state.setIn(
    ['state', 'eCommerce', 'cart'],
    _.uniq(_.compact(cartData.map((item) => item.value).toJS())).join(',')
  )

  dispatch({
    type: SET_STORE,
    payload: {
      store: state,
    },
  })
  dispatch(processCondRules('eCommerce', null, ['eCommerce']))
  dispatch(processSFAutoTrigger())
  if (typeof onUpdate === 'function') {
    onUpdate()
  } else {
    dispatch(processButtonAction(onUpdateItem, 'eCommerce', false, null))
  }
}

export const removeItemFromCart = (value, removedItem, onDelete) => (dispatch, getState) => {
  let state = getState()

  const onDeleteItem = state.getIn(
    ['project', 'Settings', 'eCommerce', 'pages', 'e_cart', 'Props', 'onDeleteItem'],
    List()
  )

  let hashAttributes = {}
  if (removedItem) {
    removedItem.get('attr', List()).map((row) => {
      if (row && isImmutable(row) && row.get('value') !== undefined) {
        hashAttributes[row.get('value')] = true
      }
    })
  } else {
    console.error('not found element')
  }

  let removeIndex = -1
  const item = state.getIn(['state', 'eCommerce', 'e_cart'], List()).find((cartItem, index) => {
    if (cartItem.get('value') === value) {
      let isMatchAttr = true
      if (cartItem.get('attr')) {
        let attributes = cartItem
          .get('attr', List())
          .filter((row) => row && isImmutable(row) && row.get('value') !== undefined)
        if (attributes.size != Object.keys(hashAttributes).length) {
          return false
        }
        attributes.map((row) => {
          if (row && isImmutable(row) && row.get('value') !== undefined) {
            if (!hashAttributes[row.get('value')]) {
              isMatchAttr = false
            }
          }
        })
        if (isMatchAttr) {
          removeIndex = index
        }
        return isMatchAttr
      } else {
        if (Object.keys(hashAttributes).length == 0) {
          removeIndex = index
          return true
        }
        return false
      }
    } else {
      return false
    }
  })

  dispatch(setElemValue(['item'], item, 'FormField', ['eCommerce']))

  state = getState()
  let cartData = state.getIn(['state', 'eCommerce', 'e_cart'], List()).filter((item, index) => index !== removeIndex)

  state = state.setIn(['state', 'eCommerce', 'e_cart'], cartData)
  setCartToLocalStorage(cartData, state)
  state = state.setIn(
    ['state', 'eCommerce', 'cart'],
    _.uniq(_.compact(cartData.map((item) => item.value).toJS())).join(',')
  )

  dispatch({
    type: SET_STORE,
    payload: {
      store: state,
    },
  })

  dispatch(processCondRules('eCommerce', null, ['eCommerce']))
  dispatch(processSFAutoTrigger())
  if (typeof onDelete === 'function') {
    onDelete()
  } else {
    dispatch(processButtonAction(onDeleteItem, 'eCommerce', false, null))
  }
}

export const removeItemAddonFromCart = (value, addonId, removedItem, onDelete) => (dispatch, getState) => {
  let state = getState()

  const onDeleteAddon = state.getIn(
    ['project', 'Settings', 'eCommerce', 'pages', 'e_cart', 'Props', 'onDeleteItem'],
    List()
  )

  const removeIndex = state
    .getIn(['state', 'eCommerce', 'e_cart'], List())
    .findIndex((item) => item.get('value') === value)

  if (removeIndex !== -1) {
    dispatch(setElemValue(['item'], removedItem, 'FormField', ['eCommerce']))

    let nextAddons = removedItem.get('addons', List()).filter((addon) => addon.get('Id') !== addonId)
    state = getState()
    let cartData = state.getIn(['state', 'eCommerce', 'e_cart'], List()).setIn([removeIndex, 'addons'], nextAddons)
    state = state.setIn(['state', 'eCommerce', 'e_cart'], cartData)
    setCartToLocalStorage(cartData, state)
    state = state.setIn(
      ['state', 'eCommerce', 'cart'],
      _.uniq(_.compact(cartData.map((item) => item.value).toJS())).join(',')
    )

    dispatch({
      type: SET_STORE,
      payload: {
        store: state,
      },
    })

    dispatch(processCondRules('eCommerce', null, ['eCommerce']))
    dispatch(processSFAutoTrigger())
    if (typeof onDelete === 'function') {
      onDelete()
    } else {
      dispatch(processButtonAction(onDeleteAddon, 'eCommerce', false, null))
    }
  }
}

export const setCartToLocalStorage = (cart, state) => {
  if (!isImmutable(cart)) {
    return false
  }
  let projectID = state.getIn(['project', '_id'])
  if (!projectID) {
    return false
  }
  try {
    ftSetLocalStorage(`e_cart_${projectID}`, JSON.stringify(cart.toJS()))
  } catch (err) {}
}

export const setSalePrice = (product) => {
  try {
    if (product) {
      let fixedPrice = parseFloat(product.get('price', 0))
      let fixedDiscountPrice = parseFloat(product.get('discountPrice', 0))
      if (isNaN(fixedPrice)) {
        fixedPrice = 0
      }
      if (isNaN(fixedDiscountPrice)) {
        fixedDiscountPrice = 0
      }

      // _.each(product.get('attr', List()).toJS(), function (row) {
      //     if (row && row.price) {
      //         let delta = parseFloat(row.price);
      //         if (!isNaN(delta)) {
      //             fixedPrice += delta

      //             if (product.get('discountPrice') !== undefined) {
      //                 fixedDiscountPrice += delta
      //             }
      //         }
      //     }
      // });

      if (
        product.get('discountPrice') !== undefined &&
        product.get('discountPrice') !== null &&
        Boolean(product.get('discountPrice'))
      ) {
        product = product.set('salePrice', fixedDiscountPrice)
      } else if (product.get('price')) {
        product = product.set('salePrice', fixedPrice)
      }
    }
  } catch (err) {
    console.error(err)
  }
  return product
}

export const resetCart = () => (dispatch, getState) => {
  let state = getState()
  state = state.setIn(['state', 'eCommerce', 'e_cart'], List())
  state = state.setIn(['widgets', 'isShowPaymentModal'], false)
  state = state.setIn(['widgets', 'selectedCustomService'], null)
  setCartToLocalStorage(List(), state)
  try {
    if (window) {
      window.ft_stripe_element = null
    }
  } catch (err) {}
  dispatch({
    type: SET_STORE,
    payload: {
      store: state,
    },
  })
}

export const resetTransaction = () => (dispatch, getState) => {
  let state = getState()
  state = state.setIn(['state', 'eCommerce', 'transaction'], Map())
  try {
    if (window) {
      window.ft_stripe_element = null
    }
  } catch (err) {}
  dispatch({
    type: SET_STORE,
    payload: {
      store: state,
    },
  })
}

export const addToCart =
  ({ value, ...rest }, count = 1, onAdd, onUpdate) =>
  (dispatch, getState) => {
    let state = getState()

    if (window.isDisableChangeCart) {
      return false
    }
    if (rest.discountPrice) {
      rest.salePrice = rest.discountPrice
    } else if (rest.price) {
      rest.salePrice = rest.price
    }

    const sfItemID = state
      .getIn(['project', 'Settings', 'sfMapping'], Map())
      .findKey((elem) => elem.get('elemUID') === 'e_cart')

    const onAddItem = state.getIn(['project', 'Settings', 'eCommerce', 'pages', 'e_cart', 'Props', 'onAddItem'], List())
    const onUpdateItem = state.getIn(
      ['project', 'Settings', 'eCommerce', 'pages', 'e_cart', 'Props', 'onUpdateItem'],
      List()
    )

    let action = List()

    let cartData = state.getIn(['state', 'eCommerce', 'e_cart'], List())
    const attr = _.compact(rest.attr || [])

    const cartItemIndex = cartData.findIndex((item) => {
      if (item.get('value') === value) {
        let isSame = true
        let itemAttr = _.compact(item.get('attr', List()).toJS() || [])
        _.each(attr, (val) => {
          if (_.findIndex(itemAttr, (v) => v.value === val?.value) === -1) {
            isSame = false
            return false
          }
        })
        return isSame
      } else {
        if (item.get('addons')) {
          let isFoundAddon = false
          item.get('addons').map((itemAddon) => {
            if (itemAddon && itemAddon.get('value') == value) {
              let isSame = true
              let itemAttr = _.compact(item.get('attr', List()).toJS() || [])
              _.each(attr, (val) => {
                if (_.findIndex(itemAttr, (v) => v.value === val?.value) === -1) {
                  isSame = false
                  return false
                }
              })
              if (isSame) {
                isFoundAddon = true
              }
            }
          })
          return isFoundAddon
        }
        return false
      }
    })

    if (cartItemIndex === -1) {
      let item = fromJS({
        value,
        ...rest,
        count,
      })
      item = setSalePrice(item)
      cartData = cartData.push(item)
      dispatch(setElemValue(['item'], item, 'FormField', ['eCommerce']))
      if (onAdd?.size > 0) {
        action = onAdd
      } else {
        if (sfItemID) {
          action = fromJS({
            actions: onAddItem,
            conditions: [],
          })
        } else {
          action = fromJS(onAddItem)
        }
      }
      // create -> map to new item
    } else {
      let addons = _.compact(rest.addons || [])
      let isAddonChanged = false
      let cardAddons = cartData.getIn([cartItemIndex, 'addons'], List()).toJS()
      if (addons.length > 0) {
        _.each(addons, (addon) => {
          let cartAddonIndex = _.findIndex(cardAddons, (row) => row.Id == addon.Id)
          if (cartAddonIndex !== -1) {
            if (
              cardAddons[cartAddonIndex].count + 1 <= cardAddons[cartAddonIndex].quantity ||
              cardAddons[cartAddonIndex].quantity === undefined ||
              cardAddons[cartAddonIndex].quantity === null
            ) {
              cardAddons[cartAddonIndex].count = cardAddons[cartAddonIndex].count + 1
            }
          } else {
            cardAddons.push(addon)
          }
        })
      } else if (cardAddons.length) {
        let cartAddonIndex = _.findIndex(cardAddons, (row) => row.Id == value)
        if (cartAddonIndex !== -1) {
          isAddonChanged = true
          if (
            cardAddons[cartAddonIndex].count + 1 <= cardAddons[cartAddonIndex].quantity ||
            cardAddons[cartAddonIndex].quantity === undefined ||
            cardAddons[cartAddonIndex].quantity === null
          ) {
            cardAddons[cartAddonIndex].count = cardAddons[cartAddonIndex].count + 1
          }
        }
      }
      cartData = cartData.setIn([cartItemIndex, 'addons'], fromJS(cardAddons))
      if (!isAddonChanged) {
        if (rest.quantity) {
          if (rest.quantity > cartData.getIn([cartItemIndex, 'count'], 1) + count) {
            cartData = cartData.setIn([cartItemIndex, 'count'], cartData.getIn([cartItemIndex, 'count'], 1) + count)
          }
        } else {
          cartData = cartData.setIn([cartItemIndex, 'count'], cartData.getIn([cartItemIndex, 'count'], 1) + count)
        }
      }

      let cartItem = cartData.getIn([cartItemIndex], Map())
      cartItem = setSalePrice(cartItem)
      dispatch(setElemValue(['item'], cartItem, 'FormField', ['eCommerce']))
      if (onAdd?.size > 0) {
        action = onUpdate
      } else {
        if (sfItemID) {
          action = fromJS({
            actions: onUpdateItem,
            conditions: [],
          })
        } else {
          action = fromJS(onUpdateItem)
        }
      }
    }

    state = getState()
    state = state.setIn(['state', 'eCommerce', 'e_cart'], cartData)
    setCartToLocalStorage(cartData, state)
    state = state.setIn(
      ['state', 'eCommerce', 'cart'],
      _.uniq(_.compact(cartData.map((item) => item.get('value')).toJS())).join(',')
    )
    dispatch({
      type: SET_STORE,
      payload: {
        store: state,
      },
    })

    dispatch(processCondRules('eCommerce', null, ['eCommerce']))
    dispatch(processSFAutoTrigger())

    if (sfItemID) {
      if (window) {
        window.isDisableChangeCart = sfItemID
      }
      const pullAction = fromJS({
        uid: uuid(),
        conditions: [],
        isAction: false,
        actions: {
          sfAction: [
            {
              items: [
                {
                  value: sfItemID,
                  order: '',
                },
              ],
            },
          ],
        },
      })
      if (List.isList(action)) {
        action = action.push(pullAction)
      } else if (Map.isMap(action)) {
        action = List.of(action, pullAction)
      }
    }

    dispatch(processButtonAction(action, 'eCommerce', false, null))

    let captions = state.getIn(['project', 'Settings', 'eCommerce', 'captions'], Map())

    let message = rest.name + ' ' + captions.getIn(['Cart', 'Added to your cart'], 'Added to your cart')

    if (window.__FT_PROJECT__API__ && window.__FT_PROJECT__API__.addToast) {
      requestAnimationFrame(() => {
        window.__FT_PROJECT__API__.addToast(message, {
          appearance: 'success',
          enabled: true,
          toastMessage: message,
          variant: 'toast',
        })
      })
    }
  }
